// material-ui
import { useTheme } from "@mui/material/styles";

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const PriseenLogo = ({ width, white }) => {
  const theme = useTheme();

  return (
    <>
      <img
        src={
          white
            ? "assets/images/logos/priseen-white.svg"
            : "assets/images/logos/priseen-logo-r.png"
        }
        alt="priseen-logo"
        width={width ? width : 150}
      />
    </>
  );
};

export default PriseenLogo;
